import React from 'react';
import { motion } from 'framer-motion';
import { FaTruck } from 'react-icons/fa';
import { IMAGES } from '../../data/images';

const milestones = [
  {
    year: '1964',
    title: 'Starten',
    description: 'Jensen ruller sin pølsevogn ind på Gentofte Station'
  },
  {
    year: '1988',
    title: 'Ny Æra',
    description: 'Allan overtager vognen og fortsætter traditionen'
  },
  {
    year: '1999',
    title: 'Bennys Tid',
    description: 'Benny træder til og løfter pølsevognen til nye højder'
  },
  {
    year: '2013',
    title: 'Næste Generation',
    description: 'Brian overtager og holder traditionerne i live'
  },
  {
    year: '2019',
    title: 'Pølsevogn På Hjul',
    description: 'Nu kan du få den ægte Bennys-oplevelse til dit arrangement!'
  }
];

export default function About() {
  return (
    <section id="about" className="relative py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Historien om Pølsevognen på Gentofte Station
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-start">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <p className="text-lg text-gray-600 leading-relaxed">
              I 1964 rullede Jensen sin pølsevogn ind på Gentofte Station – og det var startskuddet 
              til noget stort! Pølserne var ukendte, men hurtigt blev de alles yndlings-snack. 
              I 1988 overtager Allan, og i 1999 træder Benny ind og tager pølserne til nye højder.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              Og så var det, at Bennys Pølsevogn virkelig fik fart på! Vognen blev hurtigt en fast 
              del af stationens liv, og i 2013 overtager sønnen Brian, som nu holder liv i traditionen 
              og sørger for, at de gode pølser aldrig går af mode.
            </p>

            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              className="mt-8"
            >
              <img
                src={IMAGES.about.plate}
                alt="Bennys Pølsevogn gennem tiden"
                className="w-full h-auto"
              />
            </motion.div>
          </motion.div>

          <div className="space-y-6">
            {milestones.map((milestone, index) => (
              <motion.div
                key={milestone.year}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.2 }}
                className="relative pl-8 border-l-2 border-red-200"
              >
                <div className="absolute left-0 top-0 -translate-x-1/2 w-4 h-4 rounded-full bg-red-600" />
                <div className="bg-red-50 rounded-lg p-4">
                  <span className="text-red-600 font-bold">{milestone.year}</span>
                  <h3 className="text-lg font-bold text-gray-900">{milestone.title}</h3>
                  <p className="text-gray-600">{milestone.description}</p>
                  
                  {milestone.year === '2025' && (
                    <motion.a
                      href="/rental"
                      className="inline-flex items-center px-4 py-2 mt-3 bg-red-600 text-white rounded-full 
                               text-sm font-medium hover:bg-red-700 transition-colors"
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      <FaTruck className="mr-2 w-4 h-4" />
                      <span>Lej Vores Foodtruck</span>
                    </motion.a>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}